/* eslint-disable react/prop-types */
import React from 'react';
// import PropTypes from 'prop-types'
import { MenuList } from './style';
import NavItem from './NavItem';

const NavTabs = ({ children }) => (
    <MenuList>
      {children}
    </MenuList>
  );

NavTabs.propTypes = {};
NavTabs.Item = NavItem;

export default NavTabs;
